import { Component, input, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { IframeService } from '@core/services/iframe.service';

@Component({
  selector: 'app-title-container',
  imports: [],
  template: `
    <div class="title-container">
      <div class="left">
        @if (backPath() && !iframeService.isEmbedded) {
          <button type="button" (click)="navigateBack()" aria-label="Go back">
            <span class="material-symbols-outlined"> arrow_back </span>
          </button>
        }
        <ng-content> </ng-content>
      </div>
      <div>
        <ng-content select="[right]"></ng-content>
      </div>
    </div>
  `,
  styles: `
    .title-container {
      width: 100%;
      padding: 1.5rem;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .left {
        display: flex;
        align-items: center;
      }
      button {
        all: unset;
        cursor: pointer;
        display: flex;
        align-items: center;
        margin-right: 1rem;
        color: var(--text-80-color);
        span {
          font-size: 32px;
        }
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitleContainerComponent {
  backPath = input('');

  readonly router = inject(Router);
  readonly iframeService = inject(IframeService);

  navigateBack() {
    this.router.navigate([this.backPath()]);
  }
}
